import react, { useState, useEffect, useRef, useCallback, memo } from "react";
import {
  Link,
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import EventFormRequest from "./EventFormRequest";
import { Puff } from "react-loading-icons";
import GuestlistPromotersModal from "./GuestlistPromotersModal";
import FormLocation from "./_FormEditLocation";
import MusicGenresModal from "./MusicGenresModal";


import NavBar from "../../../../components/NavBar";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EventTabs from "./_EventTabs";
import EventCabec from "./_EventCabec";

const EventForm = ({ action }) => {

  let params = useParams();

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [pageLoadedFinish, setPageLoadedFinish] = useState(false);
  const [state, setState] = useState({
    form: {
      id: 0,
      name: "",
      id_venues: "",
      description: "",
      date: "",
      date_end: "",
      timezone: "",
      music_genre: [],
      event_image: "",
      event_image_url: "",
      status: "",
      location: {
        address_components: [],
        formatted_address: "",
        geometry: {
          lng: "",
          lat: "",
        },
        place_id: "",
      },
      guestlist: {
        enable: false,
        capacity: "",
        visibility: "PUBLIC",
        blockRegistry: 0,
        automationBlockEnabled: false,
        automationBlockDate: "",
        automationBlockTime: "",
        promotersList: null,
        allowAppGuestList: true,
        sendSmsInvite: true,
      },
      tables: {
        enable: false,
        list: [],
        haveAccess: true,
      },
      tickets: {
        enable: false,
        list: [],
        haveAccess: true,
      },
    },
    generalInfo: {
      venues: [],
    },
    modalGuestlistPromoters: {
      show: false,
      list: [],
    },

    modalFormLocation: {
      show: false,

    },
    modalMusicGenres: {
      show: false,
    },
    errors: {},
  });
  const [activeTab, setActiveTab] = useState("guestlist");


  useEffect(() => {
    if (
      pageLoadedFinish &&
      (!state.form.date_end || state.form.date_end.length == 0)
    ) {
      setState({
        ...state,
        form: {
          ...state.form,
          date_end: state.form.date,
        },
      });
    }
  }, [state.form.date]);

  const getInfoFormEvent = async () => {
    //setIsLoading(true);
    let id_venues = searchParams.get("venue");
    let info = await EventFormRequest.getInfoFormEvent({
      ...params,
      id_venues,
    });
    if (info && info.status) {
      setIsLoading(false);

      // Debug logging
      console.log('API Response - info.data:', info.data);
      console.log('API Response - generalInfo:', info.data.generalInfo);
      console.log('API Response - music_genres:', info.data.generalInfo?.music_genre);

      if (info.data.form.status == "CLOSED") {
        navigate("/my/events");
      }
      if (searchParams.get("venue") && !info.data.form.id_venues) {
        info.data.form.id_venues = searchParams.get("venue");
      }
      setState(prevState => ({
        ...prevState,
        ...info.data,
        form: {
          ...prevState.form,
          ...info.data.form
        }
      }));
    }
  };

  useEffect(async () => {
    document.title = "Events | Nightspot Dashboard";
    setIsLoading(true);
    await getInfoFormEvent();
    setPageLoadedFinish(true);
  }, []);

  const handlerSubmitFormEventLocation = (loc) => {
    setState((prevState) => {
      const newState = {
        ...prevState,
        form: {
          ...prevState.form,
          location: loc
        },
        modalFormLocation: {
          show: false
        }
      };
      handlerSubmitFormEvent(newState);
      return newState;
    });
  }

  const handlerShowMusicGenres = (show = true) => {
    setState({
      ...state,
      modalMusicGenres: {
        ...state.modalMusicGenres,
        show: show,
      },
    });
  };

  const handlerSaveMusicGenres = (genres) => {
    setState((prevState) => {
      const newState = {
        ...prevState,
        form: {
          ...prevState.form,
          music_genre: genres,
        },
        modalMusicGenres: {
          show: false,
        },
      };
      // Auto-save if needed, or just let the user click "Guardar"
      handlerSubmitFormEvent(newState);
      return newState;
    });
  };

  const handlerSubmitFormEvent = async (newStateUpdated = null) => {
    setIsLoading(true);
    let params = null
    console.log(newStateUpdated)
    if (newStateUpdated) {
      params = newStateUpdated.form;
    } else {
      params = state.form;
    }


    //params["status"] = status;
    //let info = await EventFormRequest.postEvent(params);
    let info = await EventFormRequest.saveEvent(params);
    if (info && info.status) {
      if (info.data) {
        setState(prevState => ({
          ...prevState,
          ...info.data,
          form: {
            ...prevState.form,
            ...info.data.form
          }
        }));
      }
      setIsLoading(false);
      toast.success("Dados guardados com sucesso.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      //navigate("/my/events");
    } else {
      setState({
        ...state,
        errors: info.errors,
      });
      toast.error(info.msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
    setIsLoading(false);
  };

  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  const handleChangeInputsLocation = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          location: {
            ...e,
          },
        },
      });
    }
  };

  const handleChangeInputsGuestList = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          guestlist: {
            ...state.form.guestlist,
            [e.target.name]: e.target.value,
          },
        },
      });
    }
  };

  const handlerChangeImage = (file) => {
    setState((prevState) => {
      const newState = {
        ...prevState,
        form: {
          ...prevState.form,
          event_image: file,
        },
      };
      handlerSubmitFormEvent(newState);
      return newState;
    });
  };

  // useEffect(() => {
  //     console.log(state)
  // }, [state])



  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#f92056" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const EventCanceled = () => {
    return (
      <div className="card ">
        <div className="card-body">
          <div className="text-center">
            <i className="fa-solid fa-circle-xmark" style={{ fontSize: '5rem', color: '#f92056' }}></i>
            <h2 className="mt-3">Evento Cancelado</h2>
            <p>Este evento foi cancelado.</p>
          </div>
          <h3 className="mt-4">O que fazer agora?</h3>
          <p>A equipa Nightspot irá analisar as transações associadas ao seu evento parara preparar o processo de reembolsos se aplicável.</p>
          <p>Caso exista alguma informação adicional que deva ser comunicada aos participantes, agradecemos que nos informe com a maior brevidade possível.</p>
          <p>Agradecemos a colaboração e permanecemos à disposição para qualquer esclarecimento.</p>
        </div>
      </div>
    )
  }

  return (
    <div>
      {/* <ToastContainer /> */}
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : state.form.status === 'CANCELED' ? <EventCanceled /> : (
              <>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb premium-breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/my/dashboard">
                        <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/my/events/">Eventos</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Gestão de Evento
                    </li>
                  </ol>
                </nav>
                <div className="row mb-2 mt-n2">
                  <div className="col-12">
                    <h1 className="campaigns-section-title fs-3 mb-0">
                      {state.form.name || (action === "create" ? "Criar Evento" : "Editar Evento")}
                    </h1>
                    <p className="campaigns-section-subtitle mb-0 small text-muted opacity-75">Gere os detalhes, bilhetes e guest list do teu evento.</p>
                  </div>
                </div>
                <EventCabec
                  state={state}
                  setState={setState}
                  handleChangeInputs={handleChangeInputs}
                  handlerSubmitFormEvent={handlerSubmitFormEvent}
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                  handlerShowMusicGenres={handlerShowMusicGenres}
                  handlerChangeImage={handlerChangeImage}
                />
                <div className="tab">
                  <EventTabs
                    handleChangeInputsGuestList={(e) => handleChangeInputsGuestList(e)}
                    state={state}
                    setState={setState}
                    handlerSubmitFormEvent={(e) => handlerSubmitFormEvent(e)}
                    setIsLoading={setIsLoading}
                    getInfoFormEvent={getInfoFormEvent}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                  />
                </div>

                <GuestlistPromotersModal
                  show={state.modalGuestlistPromoters?.show || false}
                  paramsEvent={{
                    id_venues: state.form.id_venues,
                    id: state.form.id,
                  }}
                  handleModalhide={() => {
                    setState({
                      ...state,
                      modalGuestlistPromoters: {
                        ...state.modalGuestlistPromoters,
                        show: false,
                      },
                    });
                  }}

                />
              </>

            )}
          </div>
        </div>
      </NavBar >

      <FormLocation
        show={state.modalFormLocation?.show || false}
        handleModalhide={() => {
          setState({
            ...state,
            modalFormLocation: {
              show: false
            }
          })
        }}
        info={state.form.location}
        handlerSubmit={(loc) => {
          handlerSubmitFormEventLocation(loc)
        }}
      />

      <MusicGenresModal
        show={state.modalMusicGenres?.show || false}
        handleClose={() => handlerShowMusicGenres(false)}
        selectedGenres={state.form.music_genre}
        allGenres={state.generalInfo.music_genre || []}
        onSave={handlerSaveMusicGenres}
      />
    </div >
  );
};

export default EventForm;
